import { FC } from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { Copy } from '../../assets';
import { useIsMobile } from '../../hooks';
import { getDataTracking } from '../../utils';

export interface NativeShareProps extends ButtonProps {
  title: string;
  url: string;
}

export const NativeShare: FC<NativeShareProps> = ({ children, title, url }) => {
  const isMobile = useIsMobile();
  const handleOnClick = () => {
    if (isMobile) {
      if (navigator.share && navigator.canShare({ url })) {
        navigator
          .share({
            title,
            url,
          })
          .then(() => {
            console.log('Successfully shared');
          })
          .catch((error) => {
            console.error('Something went wrong sharing the blog', error);
          });
      }
    }
  };

  return (
    <Button
      colorScheme="blue"
      leftIcon={<Copy boxSize={6} />}
      onClick={handleOnClick}
      size="lg"
      {...getDataTracking(`${children}`)}
    >
      {children}
    </Button>
  );
};
